import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-189">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-[#1B2A4A]/60 backdrop-blur-sm z-50" data-id="element-190" />

          {/* Modal Container */}
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none" data-id="element-191">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white w-full max-w-2xl max-h-[80vh] rounded-2xl shadow-2xl overflow-hidden flex flex-col pointer-events-auto" data-id="element-192">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#E2E8F0] bg-[#FDF8F0]" data-id="element-193">
                <h3 className="text-2xl font-serif font-bold text-[#1B2A4A]" data-id="element-194">
                  {title}
                </h3>
                <button onClick={onClose} className="p-2 hover:bg-[#E2E8F0] rounded-full transition-colors text-[#4A5568]" aria-label="Cerrar" data-id="element-195">
                  <X className="h-6 w-6" data-id="element-196" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto custom-scrollbar text-[#4A5568] leading-relaxed space-y-4" data-id="element-197">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}